export const PATHS = {
  Root: '/',
  Dev: '/dev',
  SignIn: '/sign-in',
  Tenants: '/tenants',
  ManageUsers: '/users',
  ManageReports: '/reports',
  ManageQuarantinedUsers: '/quarantined-users',
  ManageTestingRegistrations: '/testing-registrations',
  ManageTestingResults: '/testing-results',
  DepositionManagement: '/deposition-management',
  RepositoryManagement: '/repository-management',
  SchedulingRequests: '/scheduling-requests',
};
